import React from 'react';
import {Container,Col,Row} from 'react-bootstrap'
import '../../assets/styles/components/shared/FooterComponent.scss'

const FooterComponent = () => {
  return (
    <div>
      <footer className='footer-container'>
        <Container>
          <div className='footer-info-container  pt-5'>
            {/* <Row>
              <Col md='3'>
                <h6><strong>Enlaces rápidos</strong></h6>
                <h6>Enlaces rápidos</h6>⁄
              </Col>
              <Col md='3'>
                <h6><strong>Asistencia</strong></h6>

              </Col>
              <Col md='3'>
                <h6><strong>feedVP</strong></h6>

              </Col>
              <Col md='3'>
                <h6><strong>Suscríbete</strong></h6>

              </Col>
            </Row> */}
          </div>
          <Row className='footer-terms-social'>
              <Col md='7' className='footer-copy'>
                <p>&copy; {new Date().getFullYear()} Copyright: WeLivic, Todos los derechos reservados</p>
              </Col>
              <Col md='5' >
                <Row>
                  <Col md='2' className='footer-social'>
                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="footer__icon--container">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </Col>
                  <Col md='2' className='footer-social'>
                    <a href="https://www.facebook.com/WeLivic" target="_blank" rel="noopener noreferrer" className="footer__icon--container">
                      <i className="fab fa-facebook-square"></i>
                    </a>
                  </Col>
                  <Col md='2' className='footer-social'>
                    <a href="https://www.instagram.com/welivic/?hl=es-la" target="_blank" rel="noopener noreferrer" className="footer__icon--container">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </Col>
                  <Col md='3'  className='footer-links-terms'>
                    <a href="https://github.com/" target="_blank" rel="noopener noreferrer" > Términos </a>
                  </Col>
                  <Col md='3' className='footer-links-terms'>
                    <a href="https://github.com/" target="_blank" rel="noopener noreferrer" > Politicas </a>
                  </Col>
                </Row>
                

              </Col>              
            </Row>
            <div className="footer-copyright text-center pt-2">
                    <Container fluid>                        
                        <div className="d-flex justify-content-center poopayeLink">
                            <p>Diseñado y Desarrollado con <i className="fas fa-heart"/> y <i className="fas fa-mug-hot"/> por
                                <a href="http://poopaye.com/" target="_blank" rel="noopener noreferrer"> PooPaye SAC </a>
                            </p>
                        </div>
                    </Container>
                </div>
        </Container>
      </footer>
    </div>
  );
};

export default FooterComponent;